



document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".custom-slider-luksonslider");

  if (!slider) return;

  const wrapper = slider.querySelector(".slides");
  const dotsContainer = slider.querySelector(".dots");

  if (!wrapper || !dotsContainer) return;

  let slides = slider.querySelectorAll(".slide");

  // Only one slide
  if (slides.length <= 1) return;

  let index = 1;
  let autoSlide = null;

  /* =========================================
     CLONE FIRST & LAST SLIDE
  ========================================= */

  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);

  wrapper.appendChild(firstClone);
  wrapper.insertBefore(lastClone, slides[0]);

  slides = slider.querySelectorAll(".slide");

  /* =========================================
     INITIAL POSITION
  ========================================= */

  wrapper.style.transform = "translateX(-100%)";

  /* =========================================
     DOTS
  ========================================= */

  for (let i = 0; i < slides.length - 2; i++) {

    const dot = document.createElement("button");

    dot.type = "button";

    if (i === 0) {
      dot.classList.add("active");
    }

    dot.addEventListener("click", function () {

      index = i + 1;

      updateSlider();

      startAuto();

    });

    dotsContainer.appendChild(dot);
  }

  const dots = dotsContainer.querySelectorAll("button");

  /* =========================================
     UPDATE DOTS
  ========================================= */

  function updateDots() {

    let realIndex = index - 1;

    if (realIndex < 0) {
      realIndex = dots.length - 1;
    }

    if (realIndex >= dots.length) {
      realIndex = 0;
    }

    dots.forEach(function (dot) {

      dot.classList.remove("active");

    });

    if (dots[realIndex]) {

      dots[realIndex].classList.add("active");

    }

  }

  /* =========================================
     UPDATE SLIDER
  ========================================= */

  function updateSlider(animate = true) {

    if (!slides[index]) return;

    wrapper.style.transition = animate
      ? "transform 0.5s ease"
      : "none";

    wrapper.style.transform =
      `translateX(-${index * 100}%)`;

    updateDots();

  }

  /* =========================================
     LOOP FIX
  ========================================= */

  wrapper.addEventListener("transitionend", function () {

    if (!slides[index]) return;

    /* Last clone → first real slide */

    if (slides[index].isSameNode(firstClone)) {

      wrapper.style.transition = "none";

      index = 1;

      wrapper.style.transform =
        `translateX(-${index * 100}%)`;

      updateDots();

    }

    /* First clone → last real slide */

    if (slides[index].isSameNode(lastClone)) {

      wrapper.style.transition = "none";

      index = slides.length - 2;

      wrapper.style.transform =
        `translateX(-${index * 100}%)`;

      updateDots();

    }

  });

  /* =========================================
     AUTO SLIDE
  ========================================= */

  function startAuto() {

    clearInterval(autoSlide);

    autoSlide = setInterval(function () {

      index++;

      updateSlider();

    }, 5000);

  }

  function stopAuto() {

    clearInterval(autoSlide);

  }

  /* =========================================
     LEFT / RIGHT ARROWS
  ========================================= */

  const prevButton =
    slider.querySelector(".slider-prev");

  const nextButton =
    slider.querySelector(".slider-next");


  /* PREVIOUS */

  if (prevButton) {

    prevButton.addEventListener("click", function (e) {

      e.preventDefault();

      if (wrapper.classList.contains("is-dragging")) {
        return;
      }

      index--;

      updateSlider();

      startAuto();

    });

  }


  /* NEXT */

  if (nextButton) {

    nextButton.addEventListener("click", function (e) {

      e.preventDefault();

      if (wrapper.classList.contains("is-dragging")) {
        return;
      }

      index++;

      updateSlider();

      startAuto();

    });

  }

  /* =========================================
     MOUSE DRAG
  ========================================= */

  let startX = 0;
  let currentX = 0;
  let isDragging = false;

  wrapper.addEventListener("mousedown", function (e) {

    isDragging = true;

    wrapper.classList.add("is-dragging");

    startX = e.pageX;

    currentX = startX;

    wrapper.style.transition = "none";

    stopAuto();

  });


  wrapper.addEventListener("mousemove", function (e) {

    if (!isDragging) return;

    currentX = e.pageX;

    const diff = currentX - startX;

    wrapper.style.transform =
      `translateX(calc(${-index * 100}% + ${diff}px))`;

  });


  function finishDrag() {

    if (!isDragging) return;

    const diff = currentX - startX;

    isDragging = false;

    wrapper.classList.remove("is-dragging");


    if (diff > 80) {

      index--;

    } else if (diff < -80) {

      index++;

    }

    updateSlider();

    startAuto();

  }


  wrapper.addEventListener("mouseup", function () {

    finishDrag();

  });


  wrapper.addEventListener("mouseleave", function () {

    if (isDragging) {

      finishDrag();

    }

  });


  /* =========================================
     TOUCH SWIPE
  ========================================= */

  let touchStartX = 0;
  let touchCurrentX = 0;


  wrapper.addEventListener(
    "touchstart",
    function (e) {

      touchStartX =
        e.touches[0].clientX;

      touchCurrentX =
        touchStartX;

      wrapper.style.transition = "none";

      stopAuto();

    },
    { passive: true }
  );


  wrapper.addEventListener(
    "touchmove",
    function (e) {

      touchCurrentX =
        e.touches[0].clientX;

      const diff =
        touchCurrentX - touchStartX;

      wrapper.style.transform =
        `translateX(calc(${-index * 100}% + ${diff}px))`;

    },
    { passive: true }
  );


  wrapper.addEventListener(
    "touchend",
    function () {

      const diff =
        touchCurrentX - touchStartX;


      if (diff > 80) {

        index--;

      } else if (diff < -80) {

        index++;

      }


      updateSlider();

      startAuto();

    }
  );


  /* =========================================
     PAUSE ON HOVER
  ========================================= */

  slider.addEventListener("mouseenter", function () {

    stopAuto();

  });


  slider.addEventListener("mouseleave", function () {

    startAuto();

  });


  /* =========================================
     START SLIDER
  ========================================= */

  updateSlider(false);

  startAuto();

});